import { createContext } from "react";

import { Module, Run as RunT, Stack } from "types/generated";

type RunContextType = {
  run: RunT;
  stack: Stack | Module;
  versionId?: string;
  // undefined when detail rows were not queried; false only when they came back empty.
  hasAnsibleDetails?: boolean;
};

export const RunContext = createContext<RunContextType | undefined>(undefined);
RunContext.displayName = "RunContext";
